import styled from 'styled-components';
import {
  StyledPrGTemplateCard,
  StyledTemplateCardDetails,
  StyledPredictiveGoalsTemplateSelectionWrapper,
} from 'modules/predictiveGoals/components/Styled';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const TemplateSectionContainer = styled(StyledPredictiveGoalsTemplateSelectionWrapper)`
  display: flex;
  column-gap: ${spacing.plusHalf};
  margin-bottom: 0;
`;

export const TemplateSectionCard = styled(StyledPrGTemplateCard)`
  justify-content: center;
  flex-direction: column;
  height: ${pxToRem(288)};
  width: ${pxToRem(373)};
`;

export const TemplateSectionCardTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${spacing.half};
  min-height: ${pxToRem(75)};
`;

export const TemplateSectionCardIconContainer = styled.div<{ $color: string }>`
  display: flex;
  align-items: center;
  height: ${pxToRem(164)};
  width: ${pxToRem(293)};
  width: 100%;
  justify-content: center;
  background-color: ${(props) => props.$color};
  border-radius: ${spacing.quarter};
`;

export const TemplateSectionCardDetails = styled(StyledTemplateCardDetails)`
  text-align: center;
`;
